function initMockingbirdPremade(root) {
  if (!root || root.dataset.mbmPremadeReady === 'true') return;
  root.dataset.mbmPremadeReady = 'true';
  const shopRoot = window.Shopify?.routes?.root || '/';
  const cards = [...root.querySelectorAll('.mbm-premade-product')];
  const filters = [...root.querySelectorAll('[data-mbm-premade-filter]')];

  function filterProducts(category) {
    filters.forEach((button) => button.classList.toggle('is-active', button.dataset.mbmPremadeFilter === category));
    cards.forEach((card) => card.classList.toggle('mbm-hide', category !== 'all' && card.dataset.mbmPremadeCategory !== category));
  }
  filters.forEach((button) => button.addEventListener('click', () => filterProducts(button.dataset.mbmPremadeFilter)));
  root.querySelectorAll('[data-mbm-premade-jump]').forEach((link) => link.addEventListener('click', () => filterProducts(link.dataset.mbmPremadeJump)));

  cards.forEach((card) => {
    const variants = JSON.parse(card.querySelector('[data-mbm-premade-variants]')?.textContent || '[]');
    const selects = [...card.querySelectorAll('[data-mbm-premade-option]')];
    const customSize = card.querySelector('[data-mbm-premade-size]');
    const price = card.querySelector('[data-mbm-premade-price]');
    const image = card.querySelector('[data-mbm-premade-card-image]');
    const add = card.querySelector('[data-mbm-premade-add]');
    const status = card.querySelector('[data-mbm-premade-status]');
    const money = (cents) => new Intl.NumberFormat(undefined, { style: 'currency', currency: 'USD' }).format(cents / 100);
    const selectedVariant = () => variants.find((variant) => selects.every((select) => variant.options?.[Number(select.dataset.mbmPremadeOption) - 1] === select.value));

    function updateSelection() {
      const variant = selectedVariant();
      if (price && variant) price.textContent = money(Number(variant.price));
      const variantImage = variant?.featured_image?.src || variant?.featured_image?.url;
      if (image && variantImage) image.src = variantImage;
      if (add) {
        add.disabled = !variant || variant.available === false;
        add.textContent = variant?.available === false ? 'Unavailable' : 'Add to cart';
      }
      if (status) status.textContent = '';
    }
    selects.forEach((select) => select.addEventListener('change', updateSelection));
    add?.addEventListener('click', async () => {
      const variant = selectedVariant();
      if (customSize && !customSize.value) {
        if (status) status.textContent = 'Please choose a youth or adult size.';
        customSize.focus();
        return;
      }
      if (!variant?.id || variant.available === false) {
        if (status) status.textContent = 'That option is unavailable. Please choose another.';
        return;
      }
      add.disabled = true;
      add.textContent = 'Adding…';
      try {
        const item = { id: variant.id, quantity: 1 };
        if (customSize?.value) item.properties = { Size: customSize.value };
        const response = await fetch(`${shopRoot}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [item] }) });
        if (!response.ok) {
          const error = await response.json().catch(() => ({}));
          throw new Error(error.description || 'This item could not be added to the cart.');
        }
        window.location.assign(`${shopRoot}cart`);
      } catch (error) {
        if (status) status.textContent = error.message || 'This item could not be added. Please try again.';
        add.disabled = false;
        add.textContent = 'Add to cart';
      }
    });
    updateSelection();
  });

  const modal = root.querySelector('[data-mbm-premade-gallery]');
  const main = modal?.querySelector('[data-mbm-premade-gallery-main]');
  const title = modal?.querySelector('[data-mbm-premade-gallery-title]');
  const thumbs = modal?.querySelector('[data-mbm-premade-gallery-thumbs]');
  let trigger = null;
  function closeGallery() { modal.hidden = true; document.body.style.overflow = ''; main.src = ''; trigger?.focus(); }
  root.querySelectorAll('[data-mbm-premade-open-gallery]').forEach((button) => button.addEventListener('click', () => {
    trigger = button;
    const data = button.closest('.mbm-premade-product').querySelector('[data-mbm-premade-gallery-data]');
    const images = [...data.content.querySelectorAll('img')];
    title.textContent = data.dataset.title;
    thumbs.innerHTML = '';
    images.forEach((source, index) => {
      const thumb = document.createElement('button');
      thumb.type = 'button'; thumb.className = `mbm-gallery__thumb${index === 0 ? ' is-active' : ''}`;
      const thumbImage = source.cloneNode(); thumb.appendChild(thumbImage);
      thumb.addEventListener('click', () => { main.src = source.src; main.alt = source.alt; thumbs.querySelectorAll('.mbm-gallery__thumb').forEach((item) => item.classList.toggle('is-active', item === thumb)); });
      thumbs.appendChild(thumb);
    });
    if (images[0]) { main.src = images[0].src; main.alt = images[0].alt; }
    modal.hidden = false; document.body.style.overflow = 'hidden';
  }));
  modal?.querySelector('.mbm-gallery__close')?.addEventListener('click', closeGallery);
  modal?.querySelector('[data-mbm-premade-gallery-close]')?.addEventListener('click', closeGallery);
  modal?.addEventListener('click', (event) => { if (event.target === modal) closeGallery(); });
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && modal && !modal.hidden) closeGallery(); });
}

document.querySelectorAll('[data-mbm-premade]').forEach(initMockingbirdPremade);
document.addEventListener('shopify:section:load', (event) => initMockingbirdPremade(event.target.querySelector('[data-mbm-premade]')));
